<script setup>
import { useToggle } from '@vueuse/core';
import { vOnClickOutside } from '@vueuse/components';
import { ref } from 'vue';
import { onBeforeUnmount, onMounted } from 'vue';
import { provideDropdownContext } from './provider.js';

const props = defineProps({
  openEventName: {
    type: String,
    default: '',
  },
  closeEventName: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['close']);
const [isOpen, toggle] = useToggle(false);
const isOpenedByEvent = ref(false);

const openMenu = () => {
  isOpenedByEvent.value = true;
  if (!isOpen.value) toggle(true);
};

const closeMenuFromEvent = () => {
  isOpenedByEvent.value = false;
  if (isOpen.value) {
    emit('close');
    toggle(false);
  }
};

const toggleMenu = () => {
  isOpenedByEvent.value = false;
  toggle();
};

const closeMenu = () => {
  if (isOpenedByEvent.value) return;

  if (isOpen.value) {
    emit('close');
    toggle(false);
  }
};

provideDropdownContext({
  isOpen,
  toggle,
  closeMenu,
});

onMounted(() => {
  if (props.openEventName) {
    document.addEventListener(props.openEventName, openMenu);
  }
  if (props.closeEventName) {
    document.addEventListener(props.closeEventName, closeMenuFromEvent);
  }
});

onBeforeUnmount(() => {
  if (props.openEventName) {
    document.removeEventListener(props.openEventName, openMenu);
  }
  if (props.closeEventName) {
    document.removeEventListener(props.closeEventName, closeMenuFromEvent);
  }
});
</script>

<template>
  <div v-on-click-outside="closeMenu" class="relative space-y-2">
    <slot name="trigger" :is-open :toggle="toggleMenu" />
    <div v-if="isOpen" class="absolute">
      <slot />
    </div>
  </div>
</template>
